import { render, staticRenderFns } from "./Drill.vue?vue&type=template&id=d136654a&scoped=true&"
import script from "./Drill.vue?vue&type=script&lang=js&"
export * from "./Drill.vue?vue&type=script&lang=js&"
import style0 from "./Drill.vue?vue&type=style&index=0&id=d136654a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d136654a",
  null
  
)

export default component.exports